// src/utils/validate.js

/**
 * 校验文件类型：仅允许指定图片格式和视频
 * @param {File} file - 上传的文件对象
 * @returns {Object} - 返回校验结果对象 { valid: boolean, message: string }
 */
export function checkFileFormat(file) {
  // 1. 定义允许的图片 MIME 类型白名单
  const allowedImageTypes = [
    'image/jpeg', 'image/png', 'image/gif', 'image/heic', 'image/bmp'
  ];

  // 2. 定义允许的视频 MIME 类型白名单
  const allowedVideoTypes = [
    'video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/webm', 'video/avi'
  ];

  const allowedTypes = [...allowedImageTypes, ...allowedVideoTypes];
  const fileName = file.name.toLowerCase();

  // --- 校验逻辑 ---

  // 拦截 WebP
  if (fileName.endsWith('.webp')) {
    return { valid: false, message: '不支持上传 WebP 格式的图片！' };
  }

  // 检查白名单
  if (!allowedTypes.includes(file.type)) {
    if (file.type.startsWith('image/')) {
      return { valid: false, message: '图片仅支持 JPEG, PNG, GIF, HEIC, BMP 格式！' };
    } else if (file.type.startsWith('video/')) {
      return { valid: false, message: '视频格式不支持！' };
    }
    return { valid: false, message: '仅支持上传图片和视频文件！' };
  }

  return { valid: true, message: '' };
}